import {SCREENS} from '../../constants/screens';

/**
 * Пора ли гасить состояние КОНКРЕТНОЙ партии (режим зрителя, записанные
 * действия реплея, скрытие всплывающих окон, идентификатор миссии, режим
 * редактора миссий).
 *
 * Условие — именно УХОД с экрана игры, а не «мы сейчас не в игре». Разница не
 * косметическая: часть флагов партии выставляется ОДНИМ БАТЧЕМ со сменой
 * экрана (создание миссии ставит режим редактора вместе с переходом на выбор
 * поля), и проверка «не GAME» погасила бы такой флаг тем же коммитом — режим
 * молча перестал бы работать.
 *
 * @param {string} prevScreen - экран до перехода
 * @param {string} nextScreen - экран после перехода
 */
export const checkIfMatchSessionShouldReset = (prevScreen, nextScreen) => (
  prevScreen === SCREENS.GAME && nextScreen !== SCREENS.GAME
);
